document.addEventListener('DOMContentLoaded', async () => {
  const phoneInput = document.querySelector('input[type="tel"]');
  const tagsInput = document.getElementById('form-tags');
  const errorMsg = document.querySelector("#phone-field-error-msg");
  const validMsg = document.querySelector("#phone-field-valid-msg");
  const errorSMSMsg = document.querySelector(".sms-error-message");
  let initialCountry = "auto";
  const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
  const errorMapLocalized = [window.phoneErrorMessages.invalidNumber, window.phoneErrorMessages.invalidCountryCode, window.phoneErrorMessages.tooShort, window.phoneErrorMessages.tooLong, window.phoneErrorMessages.invalidNumber];
  const createСustomerForm = document.getElementById('custom-form-create_customer');
  const shouldUpdateTags = createСustomerForm ? true : false;
  let nationalMode;

  if (!phoneInput || typeof window.intlTelInput !== 'function') {
    console.warn("Phone input or intlTelInput library not found, skipping phone validation initialization.");
    return;
  }

  if (window.Shopify.shop == "uk-neweracap.myshopify.com") {
    initialCountry = "gb";
    nationalMode = false;
  } else {
    nationalMode = false;
    await fetch(window.shopUrl + "/browsing_context_suggestions.json")
        .then((response) => response.json())
        .then((responseJson) => {
          const userLocale = responseJson?.detected_values?.country?.handle;
          initialCountry = userLocale || "auto";
        }).catch(() => {
      initialCountry = "auto";
    });
  }

  const iti = window.intlTelInput(phoneInput, {
    loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.15.0/build/js/utils.js"),
    initialCountry: initialCountry,
    geoIpLookup: (success, failure) => {
      fetch(window.shopUrl + "/browsing_context_suggestions.json")
          .then((response) => response.json())
          .then((responseJson) => {
            const userLocale = responseJson?.detected_values?.country?.handle;
            success(userLocale);
          }).catch(() => {
        failure();
      });
    },
    nationalMode: nationalMode,
    useFullscreenPopup: false,
    allowDropdown: true,
    separateDialCode: true,
    validationNumberTypes: "MOBILE",
    onlyCountries: ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
      "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
      "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
      "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
    showFlags: true,
  });

  window.iti = iti;

  const reset = () => {
    phoneInput.classList.remove("error");
    errorMsg.innerHTML = "";
    errorMsg.classList.add("hidden");
    validMsg.classList.add("hidden");
  };

  const disableCustomerRegistration = () => {
    const submitButton = document.querySelector('#custom-form-create_customer button[type="submit"]');
    console.log("Disabling submit button", submitButton);
    if (submitButton) {
      submitButton.disabled = true;
    }
  };

  const enableCustomerRegistration = () => {
    const submitButton = document.querySelector('#custom-form-create_customer button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = false;
    }
  };

  const showError = (msg) => {
    validMsg.classList.add("hidden");
    phoneInput.classList.add("error");
    errorMsg.innerHTML = msg;
    errorMsg.classList.remove("hidden");
  };

  phoneInput.addEventListener('blur', () => {
    if (phoneInput.value && phoneInput.value.startsWith('+')) {
      const currentCountryCode = iti.getSelectedCountryData().dialCode;
      const inputValue = phoneInput.value;

      if (inputValue.includes(`+${currentCountryCode}`)) {
        phoneInput.value = inputValue.replace(`+${currentCountryCode}`, '').trim();
      }
    }

    if (!phoneInput.value.trim()) {
      reset();
      enableCustomerRegistration();

      if (shouldUpdateTags && tagsInput) {
        let tags = tagsInput.value ? tagsInput.value.split(',') : [];
        tags = tags.filter(tag => !tag.startsWith('phone:'));
        tagsInput.value = tags.join(',');
      }
    } else if (iti.isValidNumber()) {
      validMsg.classList.remove("hidden");
      enableCustomerRegistration();

      const fullPhone = iti.getNumber();
      const phoneTag = `phone:${fullPhone}`;

      if (shouldUpdateTags && tagsInput) {
        let tags = tagsInput.value ? tagsInput.value.split(',') : [];
        tags = tags.filter(tag => !tag.startsWith('phone:'));
        tags.push(phoneTag);
        tagsInput.value = tags.join(',');
      }

      if (errorSMSMsg) errorSMSMsg.style.display = 'none';
    } else {
      const errorCode = iti.getValidationError();
      let msg = errorMapLocalized[errorCode] || window.phoneErrorMessages.invalidNumber;
      showError(msg);
      disableCustomerRegistration();
    }
  });

  phoneInput.addEventListener('change', reset);
  phoneInput.addEventListener('keyup', reset);
  phoneInput.addEventListener('focus', () => {
    phoneInput.classList.add('hidden-placeholder');
  });
});